import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReadingJsonService {

  apiURL = 'assets/json/database.json';
  apiFileURL = 'assets/json/renault.json';
  
  constructor(private httpClient: HttpClient) { }
  
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  public getJSONFileData(): Promise<any> {
    return this.httpClient.get(this.apiFileURL)
      .toPromise()
      .then(response => {
        return response;
      }, error => {
      });
  }

  
  public getJSONData(): Promise<any> {
    return this.httpClient.get(this.apiURL)
      .toPromise()
      .then(response => {
        return response;
      }, error => {
      });
  }
}
